import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type CelebrationType = 'won' | 'enrolled' | 'custom';

@Injectable({
  providedIn: 'root'
})
export class CelebrationService {
  private celebrateSubject = new Subject<CelebrationType>();
  celebrate$ = this.celebrateSubject.asObservable();

  /**
   * Trigger a full-page celebration animation
   * @param type - Type of celebration (won, enrolled, started, custom)
   */
  celebrate(type: CelebrationType = 'won') {
    this.celebrateSubject.next(type);
  }

  /**
   * Trigger celebration for winning a lead
   */
  celebrateWon() {
    this.celebrate('won');
  }

  /**
   * Trigger celebration for enrolling a lead
   */
  celebrateEnrolled() {
    this.celebrate('enrolled');
  }
}